module.exports = __webpack_public_path__ + "img/burger-hover.f8ca3725.svg";